const CollapseHelper = {
    init: () => {
        $('.collapse-toggle').click(function() {
            var item = $(this).closest('.collapse-item');
            var isItemExpanded = $(item).hasClass('expanded');

            if (isItemExpanded) {
                $(item).find('.collapse-content').slideUp(300);
            } else {
                $(item).find('.collapse-content').slideDown(300);
            }

            $(item).toggleClass('expanded');
        });
    },
}

Object.freeze(CollapseHelper);

export default CollapseHelper;


// WEBPACK FOOTER //
// ./scripts/components/CollapseHelper.js